// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"9bc7f08b","739":"690eeefb"}[chunkId] + ".chunk.js";
};